module.exports = __webpack_public_path__ + "img/logo_harian_aceh.91c5f643.png";